import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://keycloak.servogpt.com',
  realm: 'servogpt',
  clientId: 'servogpt'
});

export const initializeKeycloak = () =>
  keycloak.init({
    onLoad: 'check-sso',
    pkceMethod: 'S256',
    checkLoginIframe: false,
    silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
  })
  // ⬇️ Always resolve; let callers decide what to do
  .then(() => ({ keycloak, authenticated: !!keycloak.authenticated }));

export default keycloak;
